import React from "react";
import PropTypes from "prop-types";

import Spinner from "core/icons/Spinner";

import colors from "core/colors";
import { Div } from "./styles";

const LoadingSpinner = ({ loadingColor }) => (
    <Div
        data-testid="loading-component"
        loadingColor={loadingColor ? loadingColor : null}
    >
        <p>Loading</p>
        <Spinner
            size="medium"
            fillColor={loadingColor ? loadingColor : colors.darkSkyBlue}
        />
    </Div>
);

LoadingSpinner.propTypes = {
    loadingColor: PropTypes.string
};

export default LoadingSpinner;
